const QuantidadeDeCaracteresCpf = 11;

const validarCpf = (valor) => {
  if (isNullOrWhiteSpace(valor))
    return false;

  let cpfSemMascara = valor.replace(/[^\d]+/g, '');

  if (!temTamanhoPermitidoCpf(cpfSemMascara) || todosCaracteresSaoIguais(cpfSemMascara))
    return false;

  const numeros = converterTextoComNumerosParaLista(cpfSemMascara);

  const primeiroDigito = calcularDigitoCpf(numeros, 10);
  const segundoDigito = calcularDigitoCpf(numeros, 11);

  const digitosInformados = cpfSemMascara.slice(-2);

  const digitosCalculados = `${primeiroDigito}${segundoDigito}`;

  return digitosInformados === digitosCalculados;
};

const isNullOrWhiteSpace = (valor) => {
  if (!valor) return true;
  return valor.replace(/\s/g, '').length < 1;
};

const temTamanhoPermitidoCpf = (cpf) => {
  return cpf.length === QuantidadeDeCaracteresCpf;
};

const todosCaracteresSaoIguais = (texto) => {
  return texto.split('').every(c => c === texto[0]);
};

const converterTextoComNumerosParaLista = (texto) => {
  return texto.split('').map(Number);
};

const calcularDigitoCpf = (numeros, pesoInicial) => {
  let soma = 0;

  for (let i = 0; i < pesoInicial - 1; i++) {
    soma += numeros[i] * (pesoInicial - i);
  }

  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
};

export default {
  validarCpf,
  isNullOrWhiteSpace,
  temTamanhoPermitidoCpf,
  todosCaracteresSaoIguais,
  converterTextoComNumerosParaLista,
  calcularDigitoCpf
};
